import useUpdateProjectTimeAndExpense from './useUpdateProjectTimeAndExpense';

export const initialState = ({ expenseCodes = [] }) => ({
  expenseCodes,
  isAddExpenseCodeButtonEnabled: expenseCodes.some(
    code => !code.isExpenseEntryToThisCodeAllowed
  )
});

const useFormState = ({ projectUri, expenseCodes }) => {
  const onSubmit = useUpdateProjectTimeAndExpense({
    projectUri
  });
  const initialValues = initialState({
    expenseCodes
  });

  return {
    initialValues,
    onSubmit,
    enableReinitialize: true
  };
};

export default useFormState;
